import React from 'react';
import PropTypes from 'prop-types';

import { MenuList as MUIMenuList } from '@material-ui/core';

export const MenuList = props => <MUIMenuList {...props} />;

MenuList.propTypes = {
  autoFocus: PropTypes.bool,
  autoFocusItem: PropTypes.bool,
  classes: PropTypes.object,
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
};

export default MenuList;
